import { Routes,Route } from 'react-router-dom';
import Full from './components/layout/Full';
import Page from './components/layout/Page';
import Login from './page/authlogin/Login';
import ProtectedRoute from './page/authlogin/ProtectedRoute';
import Home from "./page/home/Home";
import Settings from './page/user/SettingsUser';
import Security from './page/user/SecurityUser';
import Profile from './page/user/ProfileUser';
import Client from './page/client/Client';
import ClientDetail from './page/client/ClientDetail';
import Register from './page/Register';

export default function Main() {

  	return (
	    <Routes>
            {/* Layout full without header and footer */}
            <Route element={<Full />}>
                <Route path="/login" element={<Login />} />
            </Route>
            {/* Route protette */}
            <Route element={<Page />}>
                <Route path="/" element={<ProtectedRoute requiredRole={false} element={Home} />}  />
                <Route path="/home" element={<ProtectedRoute requiredRole={false} element={Home} />}  />
                <Route path="/profile-user" element={<ProtectedRoute requiredRole={false} element={Profile} />}  />
                <Route path="/settings-user" element={<ProtectedRoute requiredRole={false} element={Settings} />}  />
                <Route path="/security-user" element={<ProtectedRoute requiredRole={false} element={Security} />}  />
                <Route path="/client" element={<ProtectedRoute requiredRole={false} element={Client} />}  />
                <Route path="/client-detail/:id" element={<ProtectedRoute requiredRole={false} element={ClientDetail} />}  />
                <Route path="/register"  element={<ProtectedRoute requiredRole={true} roles={'ROLE_ADMIN'} element={Register} />}  />
            </Route>
            {/* /Route protette */}
		</Routes>
	);
}